import { Injectable, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';
import { MasterComponentService } from '../../services/master-component.service';
import { Configuration } from '../../configurations/shared.config';


declare var google: any;

@Injectable()
export class TransporterDetailsViewService {

    CurrentDriver: any;
    VehicleTypeName: any;
    Vehicle: any;
    VehicleTypes: any;
    transporterState: any;

    public onDetailsChanged: EventEmitter<any> = new EventEmitter<any>();

    constructor(private _http: Http) { }

    toggleDeviceDetails(transporterId: number) {
        this.onDetailsChanged.emit(transporterId);

    }

    registerCurrentStaffOnIntersetedVehiclesForDisplay(vehicleId: number, isUnRegisiter: boolean = false) {
        return this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.registerStaffOnInterestedVehicles + '/' + vehicleId + '/' + isUnRegisiter).map(res => res.json);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/transporters/transporter-details-view.service.ts